import { MoreHorizontal } from 'lucide-react';
import { Button } from '../ui/button.tsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown.tsx';
import { TableCell, TableRow } from '../ui/table.tsx';
import { useGetChildById } from '../../api/student/studentQueries.js';

const StudentRowData = ({ childId = '' }) => {
  const {
    data: childData,
    isLoading: isChildLoading,
    isError: isChildError,
  } = useGetChildById(childId);
  return (
    <>
      {isChildError ? (
        <TableRow>
          <TableCell colSpan={5} className="text-center text-red-500">
            Error loading student data.
          </TableCell>
        </TableRow>
      ) : isChildLoading ? (
        <TableRow>
          <TableCell colSpan={5} className="text-center">
            Loading...
          </TableCell>
        </TableRow>
      ) : (
        <TableRow className="hover:bg-gray-50 divide-x divide-gray-200">
          {/* <TableCell className="font-medium text-purple-700">Lebe</TableCell> */}
          <TableCell>{childData.firstName}</TableCell>
          <TableCell>{childData.lastName}</TableCell>
          <TableCell>
            {childData.parent.firstName} {childData.parent.lastName}
          </TableCell>

          <TableCell>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="h-8 w-8">
                  <MoreHorizontal className="h-4 w-4" />
                  <span className="sr-only">Open menu</span>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem>View Student Details</DropdownMenuItem>
                <DropdownMenuItem>Edit Enrollment</DropdownMenuItem>
                <DropdownMenuItem>Delete Enrollment</DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default StudentRowData;
